// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2ELXp","author":"Table_author__37sht","authorImage":"Table_authorImage__14pHf","unreadRow":"Table_unreadRow__1Hnz_"};